import React from 'react'
import './CheckCashingView.scss'
import _ from 'lodash'

import {createLazyExecution, getLanguageScope, N} from '../../../../helpers'
const _i18n = getLanguageScope('check_cashing');

import {
  Form,
  Image,
  Divider,
  Message,
  Icon,
  Label,
  Button
} from 'semantic-ui-react'

import Lightbox from 'react-images';
import ScannerDevice from '../../../../components/Devices/Scanner/containers/ScannerContainer'
import moment from "moment/moment";

import {Formik} from 'formik';
import {createCheckValidatorSchema} from '../models/formValidation'

class CheckCashing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      lightBoxIsOpen: false,
      openedImage: 0,
      display_amount: 0
    };

    this.scanImages = _.debounce(props.scanImages, 333);

    this.updateAmounts = createLazyExecution(async function _createLazyExecution(amount) {
      const {appCall, appSetObj, appSetVal} = props;

      await appSetObj({
        check_amount: N(amount),
        original_amount: N(amount)
      }, true);

      await appSetVal('updating_amounts', true);
      await appCall('updateAmounts');
      await appSetVal('updating_amounts', false);
    }, 333);
  }

  async componentDidUpdate(prevProps, prevState) {
    const {appCall, appSetVal, appSetObj, resetCheckResult, resetCheckUploading} = this.props;

    if (prevState.image_file_path_back !== this.state.image_file_path_back &&
      prevState.image_file_path_front !== this.state.image_file_path_front) {

      await appSetObj({
        s_customer_check_path_front: this.state.image_file_path_front,
        s_customer_check_path_back: this.state.image_file_path_back
      });

      if(this.state.image_file_path_front && this.state.image_file_path_back){
        await appCall('doCheckProcessing', {
          s_customer_check_path_front: this.state.image_file_path_front,
          s_customer_check_path_back: this.state.image_file_path_back
        });
      }

      await appSetVal('check_images_processing', false);
    }

    if (prevState.scanner_image_back && prevState.scanner_image_front &&
      prevState.scanner_image_back !== this.state.scanner_image_back &&
      prevState.scanner_image_front !== this.state.scanner_image_front) {

      resetCheckResult();
      resetCheckUploading();
    }

    if(!prevState.display_amount && prevState.display_amount !== this.state.display_amount){
      await this.updateAmounts(this.state.display_amount)
    }

  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.image_file_path_back !== prevState.image_file_path_back &&
      nextProps.image_file_path_front !== prevState.image_file_path_front) {
      return {
        image_file_path_back: nextProps.image_file_path_back,
        image_file_path_front: nextProps.image_file_path_front
      };
    }

    //Scanner image changes
    if (nextProps.scanner_image_back !== prevState.scanner_image_back &&
      nextProps.scanner_image_front !== prevState.scanner_image_front) {
      return {
        scanner_image_back: nextProps.scanner_image_back,
        scanner_image_front: nextProps.scanner_image_front
      };
    }

    if(!prevState.display_amount && nextProps.check_amount !== prevState.display_amount){
      return { display_amount: nextProps.check_amount }
    }

    if(nextProps.check_amount === 0){
      return { display_amount: nextProps.check_amount }
    }

    return {}
  }

  resetScanResult = () => {
    const {resetScannerResult, resetCheckResult, resetCheckUploading} = this.props;

    resetScannerResult();
    resetCheckUploading();
    resetCheckResult();
  };

  renderImages() {
    const {scanned_image_front, scanned_image_back, check_images_processing, not_ready_to_recognize, scanImages} = this.props;
    const {lightBoxIsOpen, openedImage} = this.state;

    if (!(scanned_image_front || scanned_image_back)) return (
      <Message icon>
        <Icon name='circle notched' loading/>
        <Message.Content>
          <Message.Header>{_i18n('scan_image_description')}</Message.Header>
        </Message.Content>
      </Message>
    );

    const images = _.compact([
      {url: scanned_image_front, label: _i18n('check_front_image'), key: 'front'},
      {url: scanned_image_back, label: _i18n('check_back_image'), key: 'back'}
    ]);

    return (
      <div>
        <Image.Group size={'medium'} className={'check-images'}>
          {_.map(images, (image, index) => {

            if (!image.url) {
              let labelText = _i18n('image_not_scanned');
              if (image.key === 'front') labelText = _i18n('front_image_not_scanned');
              if (image.key === 'back') labelText = _i18n('back_image_not_scanned');

              return (
                <div className={'no-scanned-label'}>
                  <Label content={labelText} icon='warning'/>
                </div>
              )
            }

            return (
              <div>
                <Image style={{cursor: 'pointer', width: 'auto'}} label={image.label} key={index} onClick={() => {
                  this.setState({lightBoxIsOpen: true, openedImage: index})
                }} src={image.url}/>
              </div>
            )
          })}
        </Image.Group>

        <Button.Group>
          <Button disabled={check_images_processing} icon='redo' labelPosition='left' content={_i18n('reset_scanning')}
                  onClick={this.resetScanResult}/>
          <Button disabled={not_ready_to_recognize} positive icon='images outline' labelPosition='right'
                  content={_i18n('recognize_images')} onClick={this.scanImages}/>
        </Button.Group>

        <Lightbox
          images={_.map(images, (image) => ({src: image.url}))}
          isOpen={lightBoxIsOpen}
          onClose={() => {
            this.setState({lightBoxIsOpen: false})
          }}
          backdropClosesModal={true}
          onClickPrev={() => this.setState({openedImage: openedImage - 1})}
          onClickNext={() => this.setState({openedImage: openedImage + 1})}
          currentImage={openedImage}
        />
      </div>
    )
  }

  renderInputs() {
    const {
      check_images_processing, check_maker_aba_number, check_maker_account_number, check_number, check_date,
      check_processing_done, check_maker_name, check_maker_address, check_maker_city,
      check_maker_state, check_maker_zip, check_raw_micr, check_payee_name, updating_amounts,
      customer_id, s_customer_id, s_customer_check_path_front, s_customer_check_path_back, customer_amount, fee,
      createTransaction,
    } = this.props;

    const { display_amount } = this.state;

    return (
      <Formik
        initialValues={{
          check_maker_aba_number,
          check_maker_account_number,
          check_maker_name,
          check_maker_address,
          check_maker_city,
          check_maker_state,
          check_maker_zip,
          check_number,
          check_date,
          check_raw_micr,
          check_payee_name,
          customer_id,
          s_customer_id,
          s_customer_check_path_front,
          s_customer_check_path_back,
          updating_amounts,
          display_amount,
        }}
        enableReinitialize={true}
        validationSchema={createCheckValidatorSchema()}
        onSubmit={(values) => createTransaction(values)}
        render={({values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched}) => (
          <Form>
            <Form.Field>
              {this.renderImages()}
            </Form.Field>

            <Form.Field>
              <Form.Input required disabled={!check_processing_done} readOnly={true}
                          loading={check_images_processing}
                          name='check_raw_micr'
                          label={_i18n('check_raw_micr')}
                          value={values.check_raw_micr}
                          error={!!(errors.check_raw_micr && touched.check_raw_micr)}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          icon='barcode' iconPosition='left'/>

              {errors.check_raw_micr && touched.check_raw_micr &&
              <Label className={'label-custom'} basic color='red' pointing>{errors.check_raw_micr}</Label>}
            </Form.Field>

            <Form.Group widths='equal'>
              <Form.Field>
                <Form.Input required disabled={!check_processing_done} loading={check_images_processing}
                            value={values.check_maker_aba_number}
                            error={!!(errors.check_maker_aba_number && touched.check_maker_aba_number)}
                            name='check_maker_aba_number' label={_i18n('aba_number')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            icon='hashtag' iconPosition='left'/>
              </Form.Field>

              {errors.check_maker_aba_number && touched.check_maker_aba_number &&
              <Label basic color='red' pointing>{errors.check_maker_aba_number}</Label>}

              <Form.Field>
                <Form.Input required disabled={!check_processing_done} loading={check_images_processing}
                            value={values.check_maker_account_number}
                            error={!!(errors.check_maker_account_number && touched.check_maker_account_number)}
                            name='check_maker_account_number'
                            label={_i18n('account_number')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            icon='hashtag' iconPosition='left'/>
              </Form.Field>

              {errors.check_maker_account_number && touched.check_maker_account_number &&
              <Label basic color='red' pointing>{errors.check_maker_account_number}</Label>}
            </Form.Group>

            <Form.Group widths='equal'>
              <Form.Field>
                <Form.Input required disabled={!check_processing_done} loading={check_images_processing}
                            value={values.check_number}
                            error={!!(errors.check_number && touched.check_number)}
                            name='check_number'
                            label={_i18n('check_number')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            icon='hashtag' iconPosition='left'/>

                {errors.check_number && touched.check_number &&
                <Label basic color='red' pointing>{errors.check_number}</Label>}
              </Form.Field>

              <Form.Field>
                <Form.Input required disabled={!check_processing_done} loading={check_images_processing}
                            value={values.check_date}
                            error={!!(errors.check_date && touched.check_date)}
                            name='check_date' label={_i18n('check_date')}
                            onChange={(e, {name, value}) => setFieldValue('check_date', moment(value).format('YYYY-MM-DD'))}
                            onBlur={() => setFieldTouched('check_date')}
                            type={'date'} icon='calendar' iconPosition='left'/>

                {errors.check_date && touched.check_date &&
                <Label basic color='red' pointing>{errors.check_date}</Label>}
              </Form.Field>
            </Form.Group>

            <Form.Field>
              <Form.Input required disabled={!check_processing_done} loading={check_images_processing}
                          value={values.check_maker_name}
                          error={!!(errors.check_maker_name && touched.check_maker_name)}
                          name='check_maker_name'
                          label={_i18n('check_maker_name')}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          icon='briefcase' iconPosition='left'/>

              {errors.check_maker_name && touched.check_maker_name &&
              <Label className={'label-custom'} basic color='red' pointing>{errors.check_maker_name}</Label>}
            </Form.Field>

            <Form.Field>
              <Form.Input required disabled={!check_processing_done} loading={check_images_processing}
                          name='check_payee_name'
                          value={values.check_payee_name}
                          error={!!(errors.check_payee_name && touched.check_payee_name)}
                          label={_i18n('check_payee_name')}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          icon='id badge' iconPosition='left'/>

              {errors.check_payee_name && touched.check_payee_name &&
              <Label className={'label-custom'} basic color='red' pointing>{errors.check_payee_name}</Label>}
            </Form.Field>

            <Form.Field>
              <Form.Input required disabled={!check_processing_done} loading={check_images_processing}
                          name='check_maker_address'
                          value={values.check_maker_address}
                          error={!!(errors.check_maker_address && touched.check_maker_address)}
                          label={_i18n('check_maker_address')}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          icon='home' iconPosition='left'/>

              {errors.check_maker_address && touched.check_maker_address &&
              <Label className={'label-custom'} basic color='red' pointing>{errors.check_maker_address}</Label>}
            </Form.Field>

            <Form.Group widths='equal'>

              <Form.Field style={{width: "33%"}}>
                <Form.Input required disabled={!check_processing_done} loading={check_images_processing}
                            name='check_maker_city'
                            value={values.check_maker_city}
                            error={!!(errors.check_maker_city && touched.check_maker_city)}
                            label={_i18n('check_maker_city')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            />

                {errors.check_maker_city && touched.check_maker_city &&
                <Label basic color='red' pointing>{errors.check_maker_city}</Label>}
              </Form.Field>

              <Form.Field style={{width: "33%"}}>
                <Form.Input required disabled={!check_processing_done} loading={check_images_processing}
                            name='check_maker_state'
                            value={values.check_maker_state}
                            error={!!(errors.check_maker_state && touched.check_maker_state)}
                            label={_i18n('check_maker_state')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            />

                {errors.check_maker_state && touched.check_maker_state &&
                <Label basic color='red' pointing>{errors.check_maker_state}</Label>}
              </Form.Field>

              <Form.Field style={{width: "33%"}}>
                <Form.Input required disabled={!check_processing_done} loading={check_images_processing}
                            name='check_maker_zip'
                            value={values.check_maker_zip}
                            error={!!(errors.check_maker_zip && touched.check_maker_zip)}
                            label={_i18n('check_maker_zip')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            />

                {errors.check_maker_zip && touched.check_maker_zip &&
                <Label basic color='red' pointing>{errors.check_maker_zip}</Label>}
              </Form.Field>

            </Form.Group>

            <Form.Group>
              <Form.Field style={{width: "33%"}}>
                <Form.Input required disabled={!check_processing_done} loading={check_images_processing}
                            name='display_amount'
                            type={'numeric'}
                            value={N(values.display_amount)}
                            error={!!(errors.display_amount)}
                            label={_i18n('check_amount')}
                            onChange={async (e, {name, value}) => {
                              setFieldValue('display_amount', N(value));
                              await this.setState(() => ({display_amount: value}));
                              this.updateAmounts.call(this, value);
                            }}
                            onBlur={handleBlur}
                            icon='money' iconPosition='left'/>

                {errors.display_amount &&
                <Label className={'label-custom'} basic color='red' pointing>{errors.display_amount}</Label>}
              </Form.Field>

              <Form.Field style={{width: "33%"}}>
                <Form.Input disabled={!check_processing_done} loading={check_images_processing || updating_amounts}
                            readOnly={true}
                            name='fee'
                            type={'numeric'}
                            value={N(fee)}
                            label={_i18n('fee')}/>
              </Form.Field>

              <Form.Field style={{width: "33%"}}>
                <Form.Input disabled={!check_processing_done} loading={check_images_processing || updating_amounts}
                            readOnly={true}
                            name='customer_amount'
                            type={'numeric'}
                            value={N(customer_amount)}
                            label={_i18n('customer_amount')}/>
              </Form.Field>
            </Form.Group>

            <Form.Field>

              <div style={{marginBottom: 20}}>
                {errors.customer_id && <Label color='red'>{errors.customer_id}</Label>}
                {errors.s_customer_id && <Label color='red'>{errors.s_customer_id}</Label>}
                {errors.s_customer_check_path_front && <Label color='red'>{errors.s_customer_check_path_front}</Label>}
                {errors.s_customer_check_path_back && <Label color='red'>{errors.s_customer_check_path_back}</Label>}
                {errors.updating_amounts && <Label color='red'>{errors.updating_amounts}</Label>}
              </div>

              <Form.Button disabled={!check_processing_done} onClick={handleSubmit} positive type='submit'>{_i18n('cash_a_check')}</Form.Button>
            </Form.Field>

          </Form>
        )}/>
    )
  }

  render() {
    const {} = this.props;

    return (
      <div>
        <ScannerDevice scanType={'check'}/>
        {this.renderInputs()}
      </div>
    )
  }

}

export default CheckCashing;


// WEBPACK FOOTER //
// ./src/components/Applications/CheckCashing/components/CheckCustomerView.js